@if (_isVisible) {
  <div class="ag-wrapper">
    @if (renderAsYesNo) {
      {{ getYesNo() }}
    } @else {
      <div class="checkbox">
        <input class="show-for-sr no-margin vertical-align-middle" type="checkbox" [checked]="_isChecked" />
        <label (click)="onClick()" class="text-align-center display-inline-block">
          <span aria-hidden="true" class="checkbox-box" [ngClass]="{ isDisabled: !_isEnabled }"><span aria-hidden="true" class="checkbox-check">&#x2714;</span></span>
        </label>
      </div>
    }
    
  </div>
}